import {secretApi} from "./api";


// https://renew-dev.deeplol.gg/summoner/strm_pro_info?status=pro&name=faker
export const proAndStreamerAPI = async ({status, name}) => {
    const url = new URL(`${process.env.REACT_APP_CACHE_API}summoner/strm_pro_info`);
    url.searchParams.set('name', name);
    url.searchParams.set('status', status);
    const result = await secretApi.get(url.toString())
    return result.data;
}
